import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import Todo from "./Todo";

export default function TodoList() {
	const todos = useSelector((state) => state.todos);
	const filters = useSelector((state) => state.filters);
	const isCompleted = useSelector((state) => state.todos.filter(todo => todo.completed === true)).length;
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchTodos);
	}, [dispatch]);

	const filterByStatus = (todo) => {
		const { status } = filters;
		switch (status) {
			case "Complete":
				return todo.completed;

			case "Incomplete":
				return !todo.completed;

			default:
				return true;
		}
	};

	const filterByColors = (todo) => {
		const { colors } = filters;
		if (colors.length > 0) {
			return colors.includes(todo?.color);
		}
		return true;
	};

	return (
		<>
			<div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
				{todos
					.filter(filterByStatus)
					.filter(filterByColors)
					.map((todo) => {
						if (!todo.completed) {
							return <Todo todo={todo} key={todo.id} />;
						} else return null;
					})}
			</div>

			{isCompleted && filters.status !== "Incomplete" && <div className="mt-6 mb-4 text-xl">All Completed</div>}
			<div className="mt-4 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
				{todos
					.filter(filterByStatus)
					.filter(filterByColors)
					.map((todo) => {
						if (todo.completed) {
							return <Todo todo={todo} key={todo.id} />;
						} else return null;
					})}
			</div>
		</>
	);
}
